export default function CostSummaryCostTableColumns() {
	return [
		{
			name: "num",
			title: "№ п/п",
			width: "30px",
			cellHorAlign: "center",
			headHorAlign: "center",
			headHeight: "30px",
			marginLeft: "0px",
			rowSpan: "2",
		},
		{
			name: "name",
			title: "Наименование затрат",
			width: "auto",
			cellHorAlign: "left",
			headHorAlign: "left",
			headHeight: "30px",
			marginLeft: "0px",
			rowSpan: "2",
		},
		{
			name: "cost",
			title: "Сметная стоимость, тыс. руб.",
			width: "700px",
			cellHorAlign: "left",
			headHorAlign: "center",
			headHeight: "25px",
			colSpan: "3",
			children: [
				{
					name: "production",
					title: "объектов произв. назначения",
					width: "230px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "not_production",
					title: "объектов непроизв. назначения",
					width: "230px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "total",
					title: "всего",
					width: "230px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
			],
		},
	];
}
